import { Badge, Card, UiIcon } from "@icg360/design-system";

import { usePoliciesList } from "data/ss-data-hooks";
import {
  capitalizeEachWord,
  getPolicyIconName,
  getPolicyStatus,
  getPolicyTypeLabel,
} from "utils";

import styles from "./policy-card.module.scss";

type PolicyCardsProps = {
  policyIds: string[];
};

export function PolicyCards({ policyIds }: PolicyCardsProps) {
  const { data } = usePoliciesList();
  const cards = policyIds.map((id) => {
    const policy = data?.find((p) => p.keystonePolicyId === id);
    if (!policy) return null;
    const address = capitalizeEachWord(policy.propertyAddress?.street1 ?? "");
    const policyStatus = getPolicyStatus(policy.policyState);
    const isActive = policyStatus === "Active";
    const icon = getPolicyIconName(policy);

    const policyTypeLabel = getPolicyTypeLabel(policy.policyType);
    const policyDescription = policyTypeLabel
      ? `${policyTypeLabel} #${policy.platformPolicyId}`
      : `Policy #${policy.platformPolicyId}`;

    return (
      <Card key={id}>
        <div className={styles.container}>
          <UiIcon name={icon} size="xl" />
          <div className={styles.content}>
            <div className={styles.policyTitle}>
              <div className={styles.policyAddress}>{address}</div>
              <Badge appearance={isActive ? "success" : "neutral"}>
                {policyStatus}
              </Badge>
            </div>
            <p className={styles.policyDesc}>{policyDescription}</p>
          </div>
        </div>
      </Card>
    );
  });

  return <div className={styles.wrap}>{cards}</div>;
}
